module.exports = __webpack_public_path__ + "static/media/ed.81414846.jpg";